export const remoteVideoStateTypes = {
    MINIMIZED: "MINIMIZED",
    NORMAL: "NORMAL",
    MAXIMIZED: "MAXIMIZED"
}
